import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef(({ className, value, label, ...props }, ref) => {
  // WCAG: a <progressbar> role MUST expose an accessible name. Consumers can
  // pass `label`, `aria-label`, or `aria-labelledby`. If none is provided we
  // synthesise a generic label so the audit doesn't fail — but components
  // should always pass a real label describing what is being measured.
  const aria = {};
  if (!props['aria-label'] && !props['aria-labelledby']) {
    aria['aria-label'] = label || 'Progress';
  }
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
        className
      )}
      {...aria}
      {...props}>
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }} />
    </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
